import React, { Fragment } from 'react'
import { Provider } from 'react-redux'
import { SvgSprite } from 'components/icon/SvgSprite'
import { Toastr } from 'components/toastr/Toastr'
import { RouterProvider, createBrowserRouter, createRoutesFromElements, Route, Navigate } from 'react-router'

import createStore from 'store/index'
import { CreateAccountContainer } from 'containers/createAccount/CreateAccountContainer'

import 'bootstrap/dist/css/bootstrap.min.css'
import './App.scss'

const store = createStore()

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/welcome" element={<CreateAccountContainer />} />
      <Route path="/create-account" element={<CreateAccountContainer />} />
      <Route path="*" element={<Navigate to="/welcome" replace />} />
    </>,
  ),
)

export const App = () => (
  <Provider store={store}>
    <Fragment>
      <RouterProvider router={router} />
      <SvgSprite />
      <Toastr />
    </Fragment>
  </Provider>
)
